import { Component, Inject } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { PopupComponent } from "src/app/services/popup/popup-component";
import { PopupRef, POPUP_INJECT } from "src/app/services/popup/popup-ref";
import { sntTranslate } from "src/app/support/translate";
import { jwtDecode } from "jwt-decode";
import { MemberWithTenant } from "src/app/services/member-auth-provider/members-with-tenant";

@Component({
  selector: "snt-provide-member-auth",
  templateUrl: "provide-member-auth.component.html",
  standalone: false
})
export class ProvideMemberAuthComponent implements PopupComponent {
  members!: MemberWithTenant[];

  isTitleVisible(): boolean {
    return true;
  }

  getTitle(): string {
    return sntTranslate(marker("Seleziona un tenant"));
  }

  constructor(
    @Inject(POPUP_INJECT.REF) private popupRef: PopupRef<MemberWithTenant>,
    @Inject(POPUP_INJECT.DATA)
    data: MemberWithTenant[]
  ) {
    this.members = data.map((memberAndTenant: MemberWithTenant) => {
      const token: { disabled: boolean } = jwtDecode(
        memberAndTenant.member.token
      );

      return {
        disabled: token.disabled || !!memberAndTenant.tenant.disabled,
        ...memberAndTenant
      };
    });
  }

  async onConfirm(member: MemberWithTenant): Promise<void> {
    await this.popupRef.close(member);
  }
}
